<template lang="pug">
div
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    template(v-if="!isOperator")
      p.text-center.my-3.h6 {{ $t('message.chooseYourPreferedResponsiveLayoutTheme') }}
      template(v-if="themeList.length > 0")
        .theme-templates
          .row
            template(v-for="(item, index) in themeList")
              .col
                .single-theme(
                  :class="{ 'active' : themeSelected != null && item.theme_code == themeSelected, 'default' : loading, 'selected-box-shadow' : themeSelected != null && item.theme_code == themeSelected }"
                  :disabled="loading"
                  :id="item.theme_code"
                  v-b-toggle="item.theme_code"
                  :title="item.theme_code"
                  @click="selectedDesign('theme', item)"
                  v-if="item.enable"
                  )
                  img.img-fluid(:src="'/assets/img/themeui/desktop/' + item.theme_code + '/' + item.theme_color + '.jpg?v1'")
                  //- https://stackoverflow.com/questions/54208842/css-triangle-bottom-right-of-parent-div
                  .theme-selected-container(v-if="item.theme_code == themeSelected")
                    .theme-selected-icon-container
                      i.fa.fa-check.text-success
                .single-theme.coming.default(v-else)
                  img.img-fluid(:src="'/assets/img/themeui/desktop/' + item.theme_code + '/' + item.theme_color + '.jpg?v1'")
                  .theme-overlay.d-block(style="opacity: 0.78;")
                  .text-coming {{ $t('ui.comingSoon') }}

        specialPagination(
          :totalRows="totalRow"
          :pageSize="pageSize"
          @pagechanged="changedPage"
        )

    template(v-if="colorList.length > 0")
      p.text-center.my-3.h6 {{ $t('message.chooseYourPreferedColor') }}
      .color-wrapper#colorWrapper
        .color-content
          .row
            .col(v-for="item in colorList")
              .single-color.pointer(
                @click="selectedDesign('color', item.theme_color)"
                :class="{ 'default' : loading, 'selected-box-shadow' : colorSelected == item.theme_color }"
                :disabled="loading"
                )
                ul
                  li(:class="item.theme_color + '-1'")
                  li(:class="item.theme_color + '-2'")
                  li(:class="item.theme_color + '-3'")
                .form-check
                  input.form-check-input(type='radio' name="themecolor" v-model="colorSelected" :value="item.theme_color")
        template(v-if="colorSelected != null")
          .col-full.order-setting
            .col-full-content
              .mt-3
                DisplayLayoutBox(:imageURL="themeSelected + '/' + colorSelected")

    div.text-right.mb-3
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')")
      b-button.ml-2(type="button" variant="info" @click="callSync")
        i.fas.fa-sync-alt
        span.ml-1 {{ $t("ui.sync_all") }}
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import DisplayLayoutBox from '@/components/siteeditor/DisplayLayoutBox.vue'
import specialPagination from '@/library/SpecialPagination.vue'

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    DisplayLayoutBox,
    specialPagination
  },
  props: {
    siteId: {
      type: Number
    },
    siteInfo: {
      type: Object
    },
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      firstTime: true,
      currentPage: 1,
      pageSize: 6,
      totalRow: 0,
      providerList: [],
      themeList: [],
      themeSelected: null,
      colorList: [],
      colorSelected: null
    };
  },
  computed: {
    selectedOperatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
  },
  mounted() {
    if(!this.isOperator)
      this.getThemeList(this.siteInfo);
    else {
      this.themeSelected = this.siteInfo.theme_code;
      this.getThemeColorList(this.siteInfo);
    }
  },
  methods: {
    changedPage: function(pageNo) {
      if(this.firstTime) {
        this.firstTime = false
        return;
      }
      this.currentPage = pageNo;
      this.getThemeList(this.siteInfo, true);
    },
    selectedDesign(type, value) {
      if (this.loading) return;

      if (type == 'provider') {
        this.providerSelected = value;
        this.themeSelected = null;
        // this.themeList = []
        this.getThemeList(value);
      } else if (type == 'theme') {
        this.themeSelected = value.theme_code;
        this.getThemeColorList(value);
      } else if (type == 'color') {
        this.colorSelected = value;
      }
    },
    getThemeProviderList(info) {
      let url = config.getThemeProviderTypeListUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
      };

      this.loading = true
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                var provider = response.data.dt;
                this.providerList = provider;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getThemeList(info, isChangePage) {
      if(this.isOperator) return
      let url = config.getThemeListWithSelectedUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        page_number: this.currentPage,
        page_size: this.pageSize,
        provider_type: '',
        theme_code: info.theme_code
      }

      this.loading = true
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                this.themeList = response.data.dt;
                this.totalRow = this.themeList.length > 0 ? this.themeList[0].totalrows : 0;
                if(isChangePage != true) {
                  this.setTheme(info);
                  this.getThemeColorList(info);
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    setTheme(data) {
      if(this.themeList.filter(item => item.theme_code == data.theme_code).length > 0) {
        this.themeSelected = this.themeList.filter(item => item.theme_code == data.theme_code)[0].theme_code;
      }
    },
    getThemeColorList(info) {
      this.colorSelected = null;
      this.colorList = []
      let url = config.getThemeColorListUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        theme_code: info.theme_code
      };
      this.loading = true;

      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.colorList = response.data.dt;
                this.colorSelected = this.colorList.filter(item => item.theme_color == info.theme_color)[0].theme_color;

                // this.colorSelected = value;
                $(document).ready(function(){
                  if(document.getElementById('colorWrapper') != null) {
                    document.getElementById('colorWrapper').scrollIntoView({
                      behavior: 'smooth'
                    });
                  }
                });
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            // console.log(error)
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    submit() {
      this.$swal({
        title: this.$t("ui.combine.update_theme"),
        text: this.$t("message.change_theme_will_replace_menu"),
        type: "info",
        showCancelButton: true,
        allowOutsideClick: false
      }).then(result => {
        if (result.value) {
          this.saveTheme();
        }
      });

      return
    },
    saveTheme() {
      let url = config.siteThemeEditUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        operator_id: this.selectedOperatorID,
        site_id: this.siteId,
        theme_code: this.themeSelected,
        theme_color: this.colorSelected
      };

      this.feedback.success = true;
      this.loading = true;

      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked");
                this.$helpers.showDialog(this.$t("ui.combine.update_theme"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                this.colorSelected = this.colorList.filter(item => item.theme_color == this.siteInfo.theme_color)[0].theme_color;
              }
            }
          } catch (error) {
            this.loading = false;
            if (error.status.toLowerCase() == "nochanges") {
              this.$emit("clicked");
            } else {
              this.feedback.success = false;
              this.feedback.status = error.status;
              if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              this.colorSelected = this.colorList.filter(item => item.theme_color == this.siteInfo.theme_color)[0].theme_color;
            }
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.handleFeedback(this.feedback.status);
        }
      );
    },
    reset() {
      this.site_name = "";
      this.feedback.success = true;
      this.feedback.status = "";
    },
    callSync() {
      this.$emit("callSync");
    }
  }
};
</script>
